










import { Vue, Component, Prop } from "vue-property-decorator";
import { ILead } from "@/models/leads";

@Component
export default class ULeadLink extends Vue {
  // Props

  @Prop({ required: true })
  public leadId!: ILead["id"];

  // Computed

  public get link() {
    return {
      type: "u-link",
      props: {
        tag: "router-link",
        to: {
          name: "adminLead",
          params: {
            leadId: this.leadId
          }
        }
      }
    };
  }
}
